import React from 'react';
import { useTheme } from 'styled-components';
import { Text } from 'app/components/atoms';
import { convertDate } from 'utils/convertDate';
import { FormattedMessage } from 'react-intl';

export const StockIndicator = ({ stockStatus }) => {
  const {
    fonts: {
      default: {
        fontSize: { ft14 },
      },
    },
    colors: {
      text: { proceed },
      default: { red },
    },
  } = useTheme();

  return (
    <>
      {stockStatus?.available === 'CompletelyOnStock' &&
        stockStatus?.quantity > 0 && (
          <Text testid="in-stock" fontSize={ft14} color={proceed}>
            <FormattedMessage
              id="stock-indicator.in-stock"
              defaultMessage="In stock"
              description="Label for stock status indicating in stock item"
            />
          </Text>
        )}
      {stockStatus?.available === 'NothingOnStock' && (
        <Text testid="not-in-stock" fontSize={ft14}>
          <FormattedMessage
            id="stock-indicator.not-in-stock"
            defaultMessage="Estimated delivery date"
            description="Display estimated delivery date if item not in stock"
          />
          {': '}
          {convertDate(stockStatus?.deliveryDate)}
        </Text>
      )}
      {(!stockStatus ||
        !['NothingOnStock', 'CompletelyOnStock'].includes(
          stockStatus?.available,
        )) && (
        <Text testid="info-unavailable" fontSize={ft14} color={red}>
          Stock information unavailable
        </Text>
      )}
    </>
  );
};
